"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentEditSession = void 0;
var stylable_panel_common_1 = require("@wixc3/stylable-panel-common");
var preset_driver_1 = require("./preset-driver");
var selector_configuration_driver_1 = require("./selector-configuration-driver");
var stylable_aggregation_1 = require("./stylable-aggregation");
var stylable_panel_translation_keys_1 = require("./stylable-panel-translation-keys");
var controller_part_utils_1 = require("./utils/controller-part-utils");
var START_PAGE = stylable_panel_common_1.StylePanelPage.CustomizationPanel;
var ComponentEditSession = /** @class */ (function () {
    function ComponentEditSession(siteStylesheetPath, stylesheetPath, variant, componentConfig, stylableDriver, changeDriver, presetStylesheetPaths, aggregationPaths) {
        var _this = this;
        this.siteStylesheetPath = siteStylesheetPath;
        this.stylesheetPath = stylesheetPath;
        this.variant = variant;
        this.componentConfig = componentConfig;
        this.stylableDriver = stylableDriver;
        this.changeDriver = changeDriver;
        this.presetStylesheetPaths = presetStylesheetPaths;
        this.aggregationPaths = aggregationPaths;
        this.presets = componentConfig.presets || [];
        this.selector = "." + variant;
        this.overrideStateSelector = "." + variant;
        this.defaultPreviewProps = componentConfig.previewProps || {};
        this.componentName = this.componentConfig.id;
        this.elements = stylableDriver.getPseudoElementsDeep(this.stylesheetPath, this.selector);
        this.controllerPartTypes = controller_part_utils_1.elementTreeSelectors(this.elements).reduce(function (controllerPartTypes, selector) {
            var controllerPartType = stylableDriver.getControllerPartType(_this.stylesheetPath, selector);
            if (controllerPartType) {
                controllerPartTypes[selector] = controllerPartType
                    .replace(/^"(.+(?="$))"$/, '$1') // remove surrounding quotes
                    .split(',')
                    .map(function (partType) { return partType.trim(); });
            }
            return controllerPartTypes;
        }, {});
        this.presetDriver = new preset_driver_1.PresetDriver({
            stylableDriver: stylableDriver,
            componentName: this.componentName,
            presets: this.presets,
            sourceClassName: this.variant,
            sheetPath: this.stylesheetPath,
            presetSheetPaths: presetStylesheetPaths,
            snapshots: this.componentConfig.snapshots,
        });
        this.selectorConfiguration = new selector_configuration_driver_1.SelectorConfigurationDriver(componentConfig.selectorConfiguration || {}, this.selector, {
            hover: { nameKey: stylable_panel_translation_keys_1.StylablePanelTranslationKeys.states.native.hoverLabel },
            focus: { nameKey: stylable_panel_translation_keys_1.StylablePanelTranslationKeys.states.native.focusLabel },
            disabled: { nameKey: stylable_panel_translation_keys_1.StylablePanelTranslationKeys.states.native.disabledLabel },
            active: { nameKey: stylable_panel_translation_keys_1.StylablePanelTranslationKeys.states.native.activeLabel },
        });
        if (this.componentConfig.initialElement) {
            this.selector = this.selectorConfiguration.selectorToVariant(this.componentConfig.initialElement);
        }
        var stylesheet = this.getStylesheet();
        if (stylesheet) {
            stylableDriver.stylable.transform(stylesheet.getMeta());
        }
        this.updateComputed();
        this.presetSectionLayouts = componentConfig.presetSectionLayouts || {
            static: {},
            theme: {},
            user: {},
        };
        this.changeDriver.openSession(this);
        this.page = START_PAGE;
    }
    ComponentEditSession.prototype.getSourceCSS = function () {
        var sheetDriver = this.getStylesheet();
        return (sheetDriver && sheetDriver.source) || '';
    };
    /**
     *
     * @param selector to change to
     * @return true iff state was updated
     */
    ComponentEditSession.prototype.setSelector = function (selector) {
        var oldSelector = this.selector;
        var oldOverrideStateSelector = this.overrideStateSelector;
        this.selector = selector;
        this.updateComputed();
        this.updateStateSelector(oldSelector, oldOverrideStateSelector);
        return !(oldOverrideStateSelector === this.overrideStateSelector);
    };
    ComponentEditSession.prototype.updateComputed = function () {
        this.updateOverrideStateSelector();
        var sheetDriver = this.getStylesheet();
        if (!sheetDriver) {
            this.computed = { states: [], usedStates: [] };
            return;
        }
        this.computed = {
            states: sheetDriver.getVariantStates(this.overrideStateSelector),
            usedStates: sheetDriver.getVariantUsedStates(this.overrideStateSelector),
        };
    };
    ComponentEditSession.prototype.getSelectorWithoutStates = function () {
        return selector_configuration_driver_1.stripStates(this.selector);
    };
    ComponentEditSession.prototype.getStylesheet = function () {
        return this.stylableDriver.getStylesheet(this.stylesheetPath);
    };
    ComponentEditSession.prototype.getSelectorDeclarations = function (selector) {
        var aggregationDriver = new stylable_aggregation_1.StylableAggregation(this.stylableDriver);
        return aggregationDriver.aggregateSelectorDeclarations(this.stylesheetPath, this.selectorConfiguration.selectorToVariant(selector));
    };
    ComponentEditSession.prototype.setSelectorDeclarations = function (selectorOrActions, declarations) {
        var _this = this;
        var simpleChangeActions = typeof selectorOrActions === 'string' ? [{ selector: selectorOrActions, declarations: declarations }] : selectorOrActions;
        this.changeDriver.changeSelectors(simpleChangeActions.map(function (simpleChangeAction) { return ({
            values: simpleChangeAction.declarations,
            selector: _this.selectorConfiguration.selectorToVariant(simpleChangeAction.selector),
        }); }));
    };
    ComponentEditSession.prototype.applyChangesToStylesheets = function (requestedChange) {
        this.changeDriver.applyStylesheetChange(requestedChange);
    };
    ComponentEditSession.prototype.updateOverrideStateSelector = function () {
        this.overrideStateSelector = this.selectorConfiguration.getPrimeElement(this.getSelectorWithoutStates());
    };
    ComponentEditSession.prototype.updateStateSelector = function (oldSelector, oldOverrideStateSelector) {
        if (oldOverrideStateSelector === this.overrideStateSelector) {
            var stateMatch = oldSelector.match(/[^:]:([^:]+)/);
            if (stateMatch && stateMatch[1]) {
                this.selector = this.getSelectorWithoutStates().replace(this.overrideStateSelector, this.overrideStateSelector + ":" + stateMatch[1]);
                return false;
            }
        }
        return;
    };
    return ComponentEditSession;
}());
exports.ComponentEditSession = ComponentEditSession;
//# sourceMappingURL=editor-edit-session.js.map